module.exports = __webpack_public_path__ + "img/rihanna.87389cca.jpg";